
<div class="modal-header">
    <h3 class="modal-title">Notification Display</h3>
    <button type="button" [tabindex]="-1" class="close" aria-label="Close" (click)="closePopUp()">
        <span aria-hidden="true" class="close-button">&times;</span>
    </button>
</div>
<div class="exprx--common-block mt-0">
    <div class="row check-envelope-task height_51rem" *ngIf="false">
        <div class="col-md-2 vertical--tabs envelope-position--for-menu new-menu height_51rem mt-0">
            <div class="col-md-10">
                <div>
                    <ul class="nav nav-pills flex-column nav-item-envelope"  orientation="vertical" data-widget="tree" (tabChange)="beforeTabChange($event)" >
                        <li>
                            <a (click)="beforeTabChange('ASAP');openSuccess();onSearch()" tabIndex="0" >
                                <h5 class="row-10 nav-link  col-md-12 padding-0" appCustomTooltip="ASAP Automatic Submission Notification" [ngClass]="[(IsActiveTabName === 'ASAP')  ? 'active': 'default_active']">
                                    {{"sideMenu.ASAP Automatic Sub Notif." | translate}}
                                </h5>
                            </a>
                        </li>
                        <li class="margin_top_0_1rem">
                            <a (click)="beforeTabChange('Control');openControlFileError();searchForControlErrorDataOnload()" tabIndex="0">
                                <h5 class="row-10 nav-link  col-md-12 padding-0" appCustomTooltip="Resolve Control File Errors"  [ngClass]="[(IsActiveTabName === 'Control') ? 'active': 'default_active']">
                                    {{"sideMenu.Control Error File" | translate}}
                                </h5>
                            </a>
                        </li>
                        <!-- <li style="margin-top: 0.1rem;">
                            <a (click)="searchNYErrors()" tabIndex="0">
                                <h5 class="row-10 nav-link active col-md-12 padding-0">
                                    {{"sideMenu.Control Error File for NY" | translate}}
                                </h5>
                            </a>
                        </li> -->
                    </ul>
                </div>
            </div>
        </div>
        <div  *ngIf="submissionNotif"class="col-md-10">
            <div class="row">
                <div class="col-5">
                    <div class="row">
                        <div class="col-5 left_1rem ">
                            <eprx-date-picker [RxSelectId]="'fromDate'" [AutoFocus]="true" [LabelText]="'From Date'"
                                [PlaceHolder]="''" [ControlName]="'fromDate'" [FormGroupName]="notificationDisplayFG"
                                [MinDate]="" [MaxDate]="maxDate">
                            </eprx-date-picker>
                        </div>
                        <div class="col-5">
                            <eprx-date-picker [RxSelectId]="'toDate'" [LabelText]="'To Date'" [PlaceHolder]="''"
                                [ControlName]="'toDate'" [FormGroupName]="notificationDisplayFG" [MinDate]=""
                                [MaxDate]="maxDate">
                            </eprx-date-picker>
                        </div>
                        <div class="col-1 p-4 left-2">
                            <i class="fa fa-search" aria-hidden="true" (click)="onSearch()" appCustomTooltip="Search"></i>
                        </div>
                    </div>
                    <span *ngIf="CountDetails && CountDetails.length">
                        <div class="col-md-12">
                            <wj-flex-grid [headersVisibility]="'Column'" [itemsSource]="displaySuccessCount" [isReadOnly]="true"
                                [selectionMode]="'None'" #successFile [ngClass]="'adding-wj-height'">
                                <wj-flex-grid-column [header]="actvHeader" [binding]="actvHeader" [visible]="true"
                                    *ngFor="let actvHeader of actvCtrlHeaders" [width]="
                                                                                            actvHeader === 'Actions'
                                                                                                ? 139
                                                                                                :actvHeader === 'State'
                                                                                                ? 65: actvHeader === 'Notification Date Time' ? 211 :actvHeader === 'Status' && (CountDetails.length > 19) ? 116: 124
                                                                                        " [minWidth]="50">
                                    <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                                        <div *ngIf="actvHeader === 'Actions'">
                                            <i class="far fa-eye actions blue-eye-icon margin--left" (click)="preview(item)"
                                                appCustomTooltip="Preview"></i>
                                            <i class="far fa-download actions blue-eye-icon margin-left-window" (click)="download(item)"
                                                appCustomTooltip="Download"></i>
                                        </div>
                                        <div *ngIf="actvHeader === 'Status'">
                                            <span>
                                                <img *ngIf="item.SuccessCount" src="assets/green-check_2.PNG"
                                                    class="succes_report" appCustomTooltip="Success Report">
                                                <img *ngIf="item.FailureCount" src="assets/red_cross_2.PNG"
                                                    class="succes_report" appCustomTooltip="Failure Report">
                                                <img *ngIf="!item.RxCount && !item.SuccessCount && !item.FailureCount"
                                                    src="assets/img/blue-----------zero.PNG" class="zero_reprot"
                                                    appCustomTooltip="Zero Report">
                                            </span>
                                        </div>
                                        <div *ngIf="!((actvHeader === 'Actions') || (actvHeader === 'Status'))"
                                            title="{{ item[actvHeader] }}">
                                            <div *ngIf="!item.UserReviewStatus">
                                                <b>{{item[actvHeader]}}</b>
                                            </div>
                                            <div *ngIf="item.UserReviewStatus">
                                                {{item[actvHeader]}}
                                            </div>
                                        </div>
                                    </ng-template>
                                </wj-flex-grid-column>
                            </wj-flex-grid>
                        </div>
                    </span>
                    <span *ngIf="CountDetails && CountDetails.length">
                    <img  src="assets/green-check_2.PNG" class="margin_left_0_5rem width_2_1rem"
                    appCustomTooltip="Success Report">
                    Success Report </span>
                    <span *ngIf="CountDetails && CountDetails.length">
                    <img src="assets/red_cross_2.PNG" class="margin_left_0_5rem width_2_1rem"
                    appCustomTooltip="Failure Report">
                    Failure Report </span>
                    <span *ngIf="CountDetails && CountDetails.length">
                    <img src="assets/img/blue-----------zero.PNG" class="width_1_7rem margin_left_7rem"
                    appCustomTooltip="Zero Report"> Zero Report </span>

                    <span *ngIf="!(CountDetails && CountDetails.length)" class="eprx--block__footer">
                        <div>
                            <span></span>
                            <i class="fa fa-file"></i><br/>
                            No Data Found!
                        </div>
                    </span>
                </div>
                <div  class="row col-md-7 height_50rem" *ngIf="pdfSrc && CountDetails && CountDetails.length">
                        <iframe [src]="pdfSrc" class="text-center" toolbar="0" width="100%" height="713px"
                            type="application/pdf"></iframe>
                </div>
            </div>
        </div>
        <div *ngIf="controlError" class="col-md-10">
            <div class="row">
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-5 text---left">
                            <p>Resolve Control File Errors</p>
                        </div>
                        <div class="col-2 top_2px">
                            <eprx-select [LabelText]="'Error Status'" [PlaceHolder]="''" [ControlName]="'statusDropdwn'" [FormGroupName]="notificationDisplayFG"
                            [HasMultiple]="false" [BindLabel]="'Name'" [BindValue]="'Id'" (TriggerSelectValue)="searchForControlErrorData($event.value)" [LabelForId]="''" [List]="[{'Id': 1,'Name':'Unresolved'},{'Id': 2, 'Name':'Resolved'},{'Id': 0, 'Name':'All'}]">
                        </eprx-select>
                        </div>
                        <div class="col-2 left_1rem">
                            <eprx-date-picker [RxSelectId]="'FromDate'" [AutoFocus]="true" [LabelText]="'From Date'"
                                [PlaceHolder]="''" [ControlName]="'FromDate'" [FormGroupName]="notificationDisplayFG"
                                [MinDate]="" [MaxDate]="maxDate">
                            </eprx-date-picker>
                        </div>
                        <div class="col-2">
                            <eprx-date-picker [RxSelectId]="'ToDate'" [LabelText]="'To Date'" [PlaceHolder]="''"
                                [ControlName]="'ToDate'" [FormGroupName]="notificationDisplayFG" [MinDate]=""
                                [MaxDate]="maxDate">
                            </eprx-date-picker>
                        </div>
                        <div class="col-1 p-4 left-2">
                            <i class="fa fa-search" aria-hidden="true" (click)="searchForControlErrorData()" appCustomTooltip="Search"></i>
                        </div>
                    </div>
                    <div class="eprx--block__content height_46rem">
                        <div class="col-12 p-1 wj-header2" *ngIf="totalRecordsLength">
                            <div class="row mt-0">
                                <div class="col-12">
                                    <div class="row">
                                        <div class="col-4 text-right--margin-left">
                                            <button class="submit print-med-guide background_orange"
                                                (click)="toggleColorLegend()">Color Legend</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <wj-flex-grid #cntrlErrorFile [headersVisibility]="'Column'" [itemsSource]="controlErrorWJ"
                            (drop)="this._storageService.storeWijmoGridDataInSession(cntrlErrorFile)" (resizedColumn)="this._storageService.storeWijmoGridDataInSession(cntrlErrorFile)"
                                class="text_transform" [isReadOnly]="true" [selectionMode]="'Row'"
                                [columnPicker]="'controlFileError'" [itemFormatter]="itemFormatter"
                                (initialized)="init(cntrlErrorFile)">
                                <wj-flex-grid-column [header]="'Actions'" [width]="78" [minWidth]="78" [maxWidth]="78">
                                    <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                                        <i class="far fa-edit actions edit--icon-color" appCustomTooltip="Edit"
                                            (click)="routeToEditRx(item)"></i>
                                        <img *ngIf="item.ErrorUpdateStatus === 2" src="assets/green-check_2.PNG"
                                            class="resolvedOrNot" appCustomTooltip="Resolved">
                                        <img *ngIf="item.ErrorUpdateStatus === 1" src="assets/red_cross_2.PNG"
                                        class="resolvedOrNot" appCustomTooltip="Unresolved">
                                    </ng-template>
                                </wj-flex-grid-column>
                                <wj-flex-grid-column [header]="rxheader['hName']" [binding]="rxheader['hName']"
                                    [visible]="rxheader['isVisible']" *ngFor="let rxheader of wjHeaders; let i = index"
                                     [width]="rxheader['width']" [minWidth]="rxheader['minWidth']" >
                                    <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                                        <div *ngIf="!(rxheader['hName'] === 'Drug Name' || rxheader['hName'] === 'Rx#'  || rxheader['hName'] === 'Status') "
                                            [style.color]="(rxheader['hName'] === 'Control Error' && item.ErrorUpdateStatus === 1)  ? 'red' : (rxheader['hName'] === 'Control Error' && item.ErrorUpdateStatus === 2 ? 'green' : null) "
                                            [title]="((item[rxheader.hName]+'')|uppercase)">
                                            {{item[rxheader['hName']]}}
                                        </div>
                                        <div *ngIf="(rxheader['hName'] === 'Rx#'  || rxheader['hName'] === 'Status')"
                                            [ngbTooltip]="rxheader['hName'] === 'Rx#' ? item['RxHoverOver'] : item['StatusHoverOver']"
                                            placement="top" triggers="mouseover:mouseleave" container="body"
                                            tooltipClass="custom_tooltip fw-bold" container="body">
                                            {{item[rxheader['hName']]}}
                                        </div>
                                        <div *ngIf="rxheader['hName'] === 'Drug Name'" [ngbTooltip]="item['DrugHoverOver']" placement = "top" triggers="mouseover:mouseleave" container="body" tooltipClass="custom_tooltip fw-bold" [ngClass]="item['tallmanDrugNameExists'] ? 'no-text-Transform' : ''">
                                            {{item[rxheader['hName']]}}
                                        </div>
                                    </ng-template>
                                    <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-item="item">
                                        <div title={{rxheader.hName}}>
                                            {{ rxheader.hName}}
                                        </div>
                                    </ng-template>
                                </wj-flex-grid-column>
                            </wj-flex-grid>
                            <div class="row mt-0">
                                <div class="col-12">
                                    <div class="row">
                                        <div class="col-2">
                                            <p >{{selectedFilter['Name'] === 'All' ? 'Total Count:' : (selectedFilter['Name'] == 'Resolved' ? 'Total Resolved Count:' : 'Total Unresolved Count:')}} {{totalRecordsLength}}</p>

                                        </div>
                                        <div class="col-2 margin_left_n8rem"  *ngIf="selectedFilter['Name'] == 'All'">
                                            <p>Resolved Count: {{resolvedCount.length}}</p>
                                        </div>
                                        <div class="col-5 margin_left_n6rem" *ngIf="selectedFilter['Name'] == 'All'">
                                            <p>Unresolved Count: {{unResolvedCount.length}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <span *ngIf="!totalRecordsLength" class="eprx--block__footer">
                            <div>
                                <span></span>
                                <i class="fa fa-file"></i><br/>
                                No Data Found!
                            </div>
                        </span>
                    </div>
                </div>
            </div>
        </div>
       <!-- <div  *ngIf="controlFileErrorNY"class="col-md-10 eprx--block__content">
            <div class="row">
                <div class="col-12">
                    <div class="row">
                        <div class="col-2" style="left:1rem">
                            <eprx-date-picker [RxSelectId]="'fromDate'" [AutoFocus]="true" [LabelText]="'From Date'"
                                [PlaceHolder]="''" [ControlName]="'fromDate'" [FormGroupName]="notificationDisplayFG"
                                [MinDate]="" [MaxDate]="maxDate">
                            </eprx-date-picker>
                        </div>
                        <div class="col-2">
                            <eprx-date-picker [RxSelectId]="'toDate'" [LabelText]="'To Date'" [PlaceHolder]="''"
                                [ControlName]="'toDate'" [FormGroupName]="notificationDisplayFG" [MinDate]=""
                                [MaxDate]="maxDate">
                            </eprx-date-picker>
                        </div>
                        <div class="col-1">
                        <eprx-input [LabelText]="'State'" [HasControl]="false" [ReadOnly]="true"
                        [InputValue]="rxInfo?.Patient?.dob  ? (rxInfo?.Patient?.dob | date:'MM/dd/yyyy') : '--'">
                        </eprx-input>
                     </div>
                        <div class="col-4">
                            <app-searchbox-global
                            id="Patient" [RxSelectId]="'Patient'" [SearchFor]="'Patient'"
                            [ShowOnlyPrescName]="true" [InputValue]="patientNamePatch" [IsAddNew]="false"
                            [DisableSerchFil]="true" [DisableRadioButtons]="true"
                            (SelectedPatient)="selectPatient($event,selectedDocument)">
                        </app-searchbox-global>
                        </div>

                        <div class="col-md-2">
                            <eprx-select [LabelText]="'Error Type'" [PlaceHolder]="'Error Type'"
                               [HasMultiple]="false" [BindLabel]="'Name'" [BindValue]="'Id'"
                               >
                            </eprx-select>
                        </div>
                        <div class="col-1 p-4 left-2-rem">
                            <i class="fa fa-search" aria-hidden="true" (click)="searchNYErrors()"></i>
                        </div>
                    </div>
                    <span>
                        <div class="col-md-12">
                            <wj-flex-grid #cntrlErrorFile [headersVisibility]="'Column'"
                            [itemsSource]="showNYErrorsWJ" [isReadOnly]="true" [selectionMode]="'Row'" [columnPicker]="'controlFileErrorForNY'"
                             (dblclick)="onRowDblclicked(cntrlErrorFile, $event)">
                            <wj-flex-grid-column [header]="'Action'" [width]="58" >
                                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                                    <i class="far fa-edit actions" (click)="routeToEditRx(item)"></i>
                                </ng-template>
                            </wj-flex-grid-column>
                            <wj-flex-grid-column  [header]="rxheader['hName']" [binding]="rxheader['hName']"
                            [visible]="rxheader['isVisible']" *ngFor="let rxheader of wjHeaders2; let i = index"  [width]="rxheader['width']" [minWidth]="rxheader['minWidth']" >
                                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                                    <div *ngIf="rxheader['hName'] !== 'NDC'" [style.color]="rxheader['hName'] === 'Control Error' ? 'red' : null" [title] ="((item[rxheader.hName]+'')|uppercase)">
                                        {{item[rxheader['hName']]}}
                                    </div>
                                    <div *ngIf="rxheader['hName'] === 'NDC'" [style.color]="rxheader['hName'] === 'Control Error' ? 'red' : null">
                                        {{item[rxheader['hName']] | mask : "AAAA0-0000-00"}}
                                    </div>
                                </ng-template>
                                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-item="item">
                                    <div title={{rxheader.hName}}>
                                        {{ rxheader.hName | uppercase}}
                                    </div>
                                </ng-template>
                            </wj-flex-grid-column>
                        </wj-flex-grid>
                        </div>
                    </span>
                </div>
            </div>
        </div> -->
    </div>
</div>
<div class="reportWriter height--unset" *ngIf="isEnableNYErrors">
<div class="exprx--common-block mt-0">
    <div class="row check-envelope-task height_51rem">
        <div class="col-md-2 pe-0" style="border-right-style: inset;height: 51.5rem !important;max-width: 14.666667% !important;left:0.1rem">
            <div #myUL class="col-md-12 mt-4 height_51rem mt-0 pe-3">
                <div class="row">
                    <ul class="col-md-12 mt-0 p-0" style="color: #222222;font-size: 1.14rem;" #treeview>
                        <li class="mb-2 p-0" style="padding: 4px;list-style-type: none !important;font-size: unset;">
                            <div class="col-12 padding_right_0_1rem" style="background: #bee4f9;color: #0b6599;border-radius:7px;line-height: 2.5rem;padding: 0 12px;font-weight:500;">
                                <div class="row">
                                    <div class="col-10 word_break">PDMP Files</div>
                                    <div class="col-2 reportcaret reportcaret-down-display color--arrow" style="cursor: pointer;float: none !important;" (click)="toggleTreeView($event)"></div>
                                </div>
                            </div>
                            <ul class="expandList active ps-0" >
                                <li class="ellpise ps-3" [class.selected]="controlError" (click)="openControlFileError();searchForControlErrorDataOnload()" ngbTooltip="Pre-submission" tooltipClass="common-tooltip" placement="right" triggers="mouseover:mouseleave" container="body">
                                    <a>
                                        <span>Validation Error(s)</span>
                                    </a>
                                </li>
                                  <li class="ellpise ps-3" [class.selected]="submissionNotif" (click)="openSuccess();onSearch(null, true)" ngbTooltip="Submission Log" placement="right" tooltipClass="common-tooltip" triggers="mouseover:mouseleave" container="body">
                                    <a>
                                        <span>Submission Log</span>
                                    </a>
                                </li>
                                <li *ngIf="pharmacyState === 'NY' && isEnableNYErrors" class="ellpise ps-3" [class.selected]="controlFileErrorNY" tooltipClass="common-tooltip" ngbTooltip="Post-submission" triggers="mouseover:mouseleave" container="body" placement="right"  (click)="openControlFileErrorForNY();searchNYErrors(null, true)">
                                    <a>
                                        <span>NY PDMP Error(s)</span>
                                    </a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="col-10">
            <div class="row">
                <div class="col-md-12 mt-2 ps-4" *ngIf="controlError">
                    <div class="row">
                        <div class="col-12 text---left">
                            <p>Validation Error(s)</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-2">
                            <eprx-date-picker [RxSelectId]="'FromDate'" [AutoFocus]="true" [LabelText]="'From Date'"
                                [PlaceHolder]="''" [ControlName]="'FromDate'" [FormGroupName]="notificationDisplayFG"
                                [MinDate]="" [MaxDate]="maxDate">
                            </eprx-date-picker>
                        </div>
                        <div class="col-2">
                            <eprx-date-picker [RxSelectId]="'ToDate'" [LabelText]="'To Date'" [PlaceHolder]="''"
                                [ControlName]="'ToDate'" [FormGroupName]="notificationDisplayFG" [MinDate]=""
                                [MaxDate]="maxDate">
                            </eprx-date-picker>
                        </div>
                        <div class="col-2 top_2px">
                            <eprx-select [LabelText]="'Error Status'" [PlaceHolder]="''" [ControlName]="'statusDropdwn'" [FormGroupName]="notificationDisplayFG"
                            [HasMultiple]="false" [BindLabel]="'Name'" [BindValue]="'Id'" (TriggerSelectValue)="searchForControlErrorData($event.value)" [LabelForId]="''" [List]="[{'Id': 1,'Name':'Unresolved'},{'Id': 2, 'Name':'Resolved'},{'Id': 0, 'Name':'All'}]">
                        </eprx-select>
                        </div>
                        <div class="col-2 p-4 left-2">
                             <button id="searchBtn" appTooltip="Search / Refresh" type="submit" class="hotkey_success" (click)="searchForControlErrorData()"  appShortcutKey [AltKey]="'f'">
                                <span>F</span>
                                Search
                            </button>
                        </div>
                    </div>
                    <div class="eprx--block__content mt-0">
                        <div class="col-12 p-1 wj-header2" >
                            <div class="row mt-0" *ngIf="totalRecordsLength">
                                <div class="col-12">
                                    <div class="row">
                                        <div class="col-4 text-right--margin-left">
                                            <button class="submit print-med-guide background_orange"
                                                (click)="toggleColorLegend()">Color Legend</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <wj-flex-grid #cntrlErrorFile [headersVisibility]="'Column'" [itemsSource]="controlErrorWJ"
                            (drop)="this._storageService.storeWijmoGridDataInSession(cntrlErrorFile)" (resizedColumn)="this._storageService.storeWijmoGridDataInSession(cntrlErrorFile)"
                                class="text_transform" [isReadOnly]="true" [selectionMode]="'Row'"
                                [columnPicker]="'controlFileError'" [itemFormatter]="itemFormatter"
                                (initialized)="init(cntrlErrorFile)"
                                [ngClass]="[!totalRecordsLength ? 'no-data wjm-grd-custom-height-42':'wjm-grd-custom-height-42']">
                                <wj-flex-grid-column [header]="'Actions'" [width]="78" [minWidth]="78" [maxWidth]="78">
                                    <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                                        <i class="far fa-edit actions edit--icon-color" appCustomTooltip="Edit"
                                            (click)="routeToEditRx(item)"></i>
                                        <img *ngIf="item.ErrorUpdateStatus === 2" src="assets/green-check_2.PNG"
                                            class="resolvedOrNot" appCustomTooltip="Resolved">
                                        <img *ngIf="item.ErrorUpdateStatus === 1" src="assets/red_cross_2.PNG"
                                        class="resolvedOrNot" appCustomTooltip="Unresolved">
                                    </ng-template>
                                </wj-flex-grid-column>
                                <wj-flex-grid-column [header]="rxheader['hName']" [binding]="rxheader['hName']"
                                    [visible]="rxheader['isVisible']" *ngFor="let rxheader of wjHeaders; let i = index"
                                     [width]="rxheader['width']" [minWidth]="rxheader['minWidth']" >
                                    <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                                        <div *ngIf="!(rxheader['hName'] === 'Drug Name' || rxheader['hName'] === 'Rx#'  || rxheader['hName'] === 'Status') "
                                            [style.color]="(rxheader['hName'] === 'Control Error' && item.ErrorUpdateStatus === 1)  ? 'red' : (rxheader['hName'] === 'Control Error' && item.ErrorUpdateStatus === 2 ? 'green' : null) "
                                            [title]="((item[rxheader.hName]+'')|uppercase)">
                                            {{item[rxheader['hName']]}}
                                        </div>
                                        <div *ngIf="(rxheader['hName'] === 'Rx#'  || rxheader['hName'] === 'Status')"
                                            [ngbTooltip]="rxheader['hName'] === 'Rx#' ? item['RxHoverOver'] : item['StatusHoverOver']"
                                            placement="top" triggers="mouseover:mouseleave" container="body"
                                            tooltipClass="custom_tooltip fw-bold" container="body">
                                            {{item[rxheader['hName']]}}
                                        </div>
                                        <div *ngIf="rxheader['hName'] === 'Drug Name'" [ngbTooltip]="item['DrugHoverOver']" placement = "top" triggers="mouseover:mouseleave" container="body" tooltipClass="custom_tooltip fw-bold" [ngClass]="item['tallmanDrugNameExists'] ? 'no-text-Transform' : ''">
                                            {{item[rxheader['hName']]}}
                                        </div>
                                    </ng-template>
                                    <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-item="item">
                                        <div title={{rxheader.hName}}>
                                            {{ rxheader.hName}}
                                        </div>
                                    </ng-template>
                                </wj-flex-grid-column>
                                <app-no-data-found *ngIf="!totalRecordsLength"></app-no-data-found>
                            </wj-flex-grid>
                            <app-eprx-pagination [TotalCount]="totalRecordsLength" *ngIf="totalRecordsLength"
                            (OnPageSelected)="setPage($event, 'contrlError')"
                            (OnSizeSelected)="setSize($event, 'contrlError')"
                            [GridName]="'cntrlErrorGrid'"
                                [WijmoName]="cntrlErrorFile"
                                [PageNumber]="pageNumber"
                                [PageSize]="pageSize"
                                (OnFocusOut)="focusToFirst($event)"
                                ></app-eprx-pagination>
                            <div class="row mt-0">
                                <div class="col-12">
                                    <div class="row">
                                        <div class="col-2">
                                            <p >{{selectedFilter?.['Name'] === 'All' ? 'Total Count:' : (selectedFilter?.['Name'] == 'Resolved' ? 'Total Resolved Count:' : 'Total Unresolved Count:')}} {{totalRecordsLength}}</p>

                                        </div>
                                        <div class="col-2 margin_left_n8rem"  *ngIf="selectedFilter?.['Name'] == 'All'">
                                            <p>Resolved Count: {{resolvedCount.length}}</p>
                                        </div>
                                        <div class="col-5 margin_left_n6rem" *ngIf="selectedFilter?.['Name'] == 'All'">
                                            <p>Unresolved Count: {{unResolvedCount.length}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="submissionNotif" class="col-md-12 mt-2 ps-4">
                    <div class="row">
                        <div class="col-12 text---left">
                            <p>Submission Log</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-2">
                            <eprx-date-picker [RxSelectId]="'fromDate'" [AutoFocus]="true" [LabelText]="'From Date'"
                                        [PlaceHolder]="''" [ControlName]="'fromDate'" [FormGroupName]="notificationDisplayFG"
                                        [MinDate]="" [MaxDate]="maxDate">
                            </eprx-date-picker>
                        </div>
                        <div class="col-2">
                            <eprx-date-picker [RxSelectId]="'toDate'" [LabelText]="'To Date'" [PlaceHolder]="''"
                                [ControlName]="'toDate'" [FormGroupName]="notificationDisplayFG" [MinDate]=""
                                [MaxDate]="maxDate">
                            </eprx-date-picker>
                        </div>
                        <div class="col-2 top_2px">
                            <eprx-select [LabelText]="'Submission Type'" [PlaceHolder]="''" [ControlName]="'subType'" [FormGroupName]="notificationDisplayFG"
                            [HasMultiple]="false" [BindLabel]="'Name'" [BindValue]="'Id'" (TriggerSelectValue)="onSearch($event.value)" [LabelForId]="''" [List]="[{Id:2 ,Name:'All'},{Id:0, Name:'Manual'},{Id:1,Name:'Auto'}]">
                        </eprx-select>
                        </div>
                        <div class="col-2 p-4 left-2">
                             <button id="searchBtn" appTooltip="Search / Refresh" type="submit" class="hotkey_success" (click)="onSearch()"  appShortcutKey [AltKey]="'f'">
                                <span>F</span>
                                Search
                            </button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 ps-0">
                            <div class="col-md-12">
                                <wj-flex-grid [headersVisibility]="'Column'" [itemsSource]="displaySuccessCount" [isReadOnly]="true" [columnPicker]="'submissionLog'"
                                    [selectionMode]="'None'" #successFile class="text_transform" [ngClass]="[!totalCount ? 'no-data adding-wj-height':'adding-wj-height']" (initialized)="init(successFile)"
                                    (drop)="this._storageService.storeWijmoGridDataInSession(successFile)" (resizedColumn)="this._storageService.storeWijmoGridDataInSession(successFile)">
                                    <wj-flex-grid-column [header]="rxheader['hName']" [binding]="rxheader['hName']"
                                    [visible]="rxheader['isVisible']" *ngFor="let rxheader of wjHeaders3; let i = index"
                                     [width]="rxheader['width']" [minWidth]="rxheader['minWidth']" >
                                    <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                                        <div *ngIf="!(rxheader['hName'] === 'Report Status' || rxheader['hName'] === 'Submission Status')"
                                            [title]="((item[rxheader.hName]+'')|uppercase)">
                                            <div *ngIf="!item.UserReviewStatus">
                                                 <b>{{item[rxheader['hName']]}}</b>
                                            </div>
                                            <div *ngIf="item.UserReviewStatus">
                                                {{item[rxheader['hName']]}}
                                            </div>
                                        </div>
                                        <div *ngIf="rxheader['hName'] === 'Report Status'">
                                                <span>
                                                    <span *ngIf="item.SuccessCount" class="report--Status success" ngbTooltip="Success Report" tooltipClass="common-tooltip" placement = "top" triggers="mouseover:mouseleave" container="body">Successful</span>
                                                    <span *ngIf="item.ErrorCount" class="report--Status error" ngbTooltip="Failure Report" tooltipClass="common-tooltip" placement = "top" triggers="mouseover:mouseleave" container="body">Failed</span>
                                                    <span *ngIf="!item.RxCount && !item.SuccessCount && !item.ErrorCount" class="report--Status zero" ngbTooltip="Zero Report" tooltipClass="common-tooltip" placement = "top" triggers="mouseover:mouseleave" container="body">Zero Report</span>
                                                    <!-- <img *ngIf="item.SuccessCount"
                                                        class="succes_report report--Status success">
                                                    <img *ngIf="item.FailureCount"
                                                        class="succes_report report--Status error">
                                                    <img *ngIf="!item.RxCount && !item.SuccessCount && !item.FailureCount"
                                                        class="zero_reprot report--Status zero"
                                                        > -->
                                                </span>
                                        </div>
                                        <div *ngIf="rxheader['hName'] === 'Submission Status'">
                                                <span>
                                                    <!-- Single Tick 2,0-->
                                                    <i *ngIf="item.FTPUploadStatus === submissionStatusEnums.FTPSuccess && item.PDMPUploadStatus === submissionStatusEnums.PDMPPending" class="succes_report fa-kit fa-circle-check color-green icon-font-size ms-0" ngbTooltip="File is being submitted. Please check back shortly." tooltipClass="common-tooltip" placement = "top" triggers="mouseover:mouseleave" container="body"></i>
                                                    <!-- Double Tick  2,2-->
                                                    <i *ngIf="item.FTPUploadStatus === submissionStatusEnums.FTPSuccess && item.PDMPUploadStatus === submissionStatusEnums.PDMPSuccess" class="fas fa-check-double color-green icon-font-size ms-0" ngbTooltip="File submitted successfully." placement = "top" triggers="mouseover:mouseleave" tooltipClass="common-tooltip" container="body"></i>
                                                    <!-- Single Cross 1 -->
                                                    <i *ngIf="item.FTPUploadStatus === submissionStatusEnums.FTPFailed" class="succes_report fa-kit fa-circle-xmark color-red icon-font-size ms-0" ngbTooltip="Internal error occurred. Please contact support." placement = "top" triggers="mouseover:mouseleave" tooltipClass="common-tooltip" container="body"></i>
                                                    <!-- Single Tick and Single Cross 2,1 -->
                                                    <span *ngIf="item.FTPUploadStatus === submissionStatusEnums.FTPSuccess && item.PDMPUploadStatus === submissionStatusEnums.PDMPFailed" ngbTooltip="Submission failed. Please contact support." tooltipClass="common-tooltip" placement = "top" triggers="mouseover:mouseleave" container="body">
                                                        <i class="succes_report fa-kit fa-circle-check color-green icon-font-size ms-0"></i>
                                                        <i class="succes_report fa-kit fa-circle-xmark color-red icon-font-size ms-0"></i>
                                                    </span>

                                                    <!-- <i *ngIf="item.FTPUploaded && item.SubmittedToPdmp === null"
                                                        class="succes_report fa-kit fa-circle-check color-green icon-font-size ms-0" ngbTooltip="File is being submitted. Please check back shortly." placement = "top" triggers="mouseover:mouseleave" container="body"></i>
                                                    <i *ngIf="item.FTPUploaded && item.SubmittedToPdmp" ngbTooltip="File submitted successfully." class="fas fa-check-double color-green icon-font-size ms-0" placement = "top" triggers="mouseover:mouseleave" container="body"></i> -->
                                                    <!-- <img *ngIf="item.FTPUploaded && item.SubmittedToPdmp"
                                                        class="succes_report fas fa-check-double color-green" ngbTooltip="File submitted successfully."> -->
                                                    <!-- <i *ngIf="!item.FTPUploaded"
                                                        class="succes_report fa-kit fa-circle-xmark color-red icon-font-size ms-0" ngbTooltip="Internal error occurred. Please contact support." placement = "top" triggers="mouseover:mouseleave" container="body"></i>
                                                    <span *ngIf="item.FTPUploaded && item.SubmittedToPdmp === false" ngbTooltip="Submission failed. Please contact support." placement = "top" triggers="mouseover:mouseleave" container="body">
                                                        <i class="succes_report fa-kit fa-circle-check color-green icon-font-size ms-0"></i>
                                                        <i class="succes_report fa-kit fa-circle-xmark color-red icon-font-size ms-0"></i>
                                                    </span> -->
                                                    
                                                </span>
                                        </div>
                                    </ng-template>
                                    <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-item="item">
                                        <div title={{rxheader.hName}}>
                                            {{ rxheader.hName}}
                                        </div>
                                    </ng-template>
                                </wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Actions'" [width]="78" [minWidth]="78" [maxWidth]="78">
                                        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                                            <i class="far fa-download actions blue-eye-icon" (click)="download(item)"
                                                appCustomTooltip="Download"></i>
                                            <i class="far fa-eye actions blue-eye-icon margin-left-window" (click)="preview(item)"
                                                appCustomTooltip="Preview"></i>
                                        </ng-template>
                                    </wj-flex-grid-column>
                                <app-no-data-found *ngIf="!CountDetails?.length"></app-no-data-found>
                                </wj-flex-grid>
                                <div class="col padding-0">
                                    <div class="col-md-12 padding-0">
                                        <app-eprx-pagination *ngIf="totalCount" [TotalCount]="totalCount" [WijmoName]="successFile"
                                            [GridName]="'SubmissionLogFile'" (OnPageSelected)="setPage($event, 'submNtif')"
                                            (OnSizeSelected)="setSize($event, 'submNtif')" (OnFocusOut)="focusToFirst($event)">
                                        </app-eprx-pagination>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div  class="col-md-6" *ngIf="pdfSrc && CountDetails && CountDetails.length">
                                <iframe [src]="pdfSrc" class="text-center" toolbar="0" width="100%" height="560px"
                                    type="application/pdf"></iframe>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 mt-2 ps-4" *ngIf="controlFileErrorNY">
                    <div class="row">
                        <div class="col-12 text---left">
                            <p>NY PDMP Error(s)</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-2">
                            <eprx-date-picker [RxSelectId]="'FromDate'" [AutoFocus]="true" [LabelText]="'From Date'"
                                [PlaceHolder]="''" [ControlName]="'FromDate'" [FormGroupName]="notificationDisplayFG"
                                [MinDate]="" [MaxDate]="maxDate">
                            </eprx-date-picker>
                        </div>
                        <div class="col-2">
                            <eprx-date-picker [RxSelectId]="'ToDate'" [LabelText]="'To Date'" [PlaceHolder]="''"
                                [ControlName]="'ToDate'" [FormGroupName]="notificationDisplayFG" [MinDate]=""
                                [MaxDate]="maxDate">
                            </eprx-date-picker>
                        </div>
                        <div class="col-2 top_2px">
                            <eprx-select [LabelText]="'Error Status'" [PlaceHolder]="''" [ControlName]="'statusDropdwn'" [FormGroupName]="notificationDisplayFG"
                            [HasMultiple]="false" [BindLabel]="'Name'" [BindValue]="'Id'" (TriggerSelectValue)="searchNYErrors($event.value)" [LabelForId]="''" [List]="[{'Id': 1,'Name':'Unresolved'},{'Id': 2, 'Name':'Resolved'},{'Id': 0, 'Name':'All'}]">
                        </eprx-select>
                        </div>
                        <div class="col-2 p-4 left-2">
                             <button id="searchBtn" appTooltip="Search / Refresh" type="submit" class="hotkey_success" (click)="searchNYErrors()"  appShortcutKey [AltKey]="'f'">
                                <span>F</span>
                                Search
                            </button>
                        </div>
                    </div>
                    <div class="eprx--block__content mt-0">
                        <div class="col-12 p-1 wj-header2" >
                            <div class="row mt-0" *ngIf="totalNYRecordsLength">
                                <div class="col-12">
                                    <div class="row">
                                        <div class="col-4 text-right--margin-left">
                                            <button class="submit print-med-guide background_orange"
                                                (click)="toggleColorLegend()">Color Legend</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <wj-flex-grid #NYErrorFile [headersVisibility]="'Column'" [itemsSource]="showNYErrorsWJ"
                            (drop)="this._storageService.storeWijmoGridDataInSession(NYErrorFile)" (resizedColumn)="this._storageService.storeWijmoGridDataInSession(NYErrorFile)"
                                class="text_transform" [isReadOnly]="true" [selectionMode]="'Row'"
                                [columnPicker]="'NYFileError'" [itemFormatter]="itemFormatter"
                                (initialized)="init(NYErrorFile)"
                                [ngClass]="[!totalNYRecordsLength ? 'no-data wjm-grd-custom-height-42':'wjm-grd-custom-height-42']">
                                <wj-flex-grid-column [header]="'Actions'" [width]="78" [minWidth]="78" [maxWidth]="78">
                                    <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                                        <i class="far fa-edit actions edit--icon-color" appCustomTooltip="Edit"
                                            (click)="routeToEditRx(item, 'NYErrors')"></i>
                                        <img *ngIf="item.ErrorUpdateStatus === 2" src="assets/green-check_2.PNG"
                                            class="resolvedOrNot" appCustomTooltip="Resolved">
                                        <img *ngIf="item.ErrorUpdateStatus === 1" src="assets/red_cross_2.PNG"
                                        class="resolvedOrNot" appCustomTooltip="Unresolved">
                                    </ng-template>
                                </wj-flex-grid-column>
                                <wj-flex-grid-column [header]="rxheader['hName']" [binding]="rxheader['hName']"
                                    [visible]="rxheader['isVisible']" *ngFor="let rxheader of wjHeaders2; let i = index"
                                     [width]="rxheader['width']" [minWidth]="rxheader['minWidth']" >
                                    <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                                        <div *ngIf="!(rxheader['hName'] === 'Drug Name' || rxheader['hName'] === 'Rx#'  || rxheader['hName'] === 'Status') "
                                            [style.color]="(rxheader['hName'] === 'Control Error' && item.ErrorUpdateStatus === 1)  ? 'red' : (rxheader['hName'] === 'Control Error' && item.ErrorUpdateStatus === 2 ? 'green' : null) "
                                            [title]="((item[rxheader.hName]+'')|uppercase)">
                                            {{item[rxheader['hName']]}}
                                        </div>
                                        <div *ngIf="(rxheader['hName'] === 'Rx#'  || rxheader['hName'] === 'Status')"
                                            [ngbTooltip]="rxheader['hName'] === 'Rx#' ? item['RxHoverOver'] : item['StatusHoverOver']"
                                            placement="top" triggers="mouseover:mouseleave" container="body"
                                            tooltipClass="custom_tooltip fw-bold" container="body">
                                            {{item[rxheader['hName']]}}
                                        </div>
                                        <div *ngIf="rxheader['hName'] === 'Drug Name'" [ngbTooltip]="item['DrugHoverOver']" placement = "top" triggers="mouseover:mouseleave" container="body" tooltipClass="custom_tooltip fw-bold" [ngClass]="item['tallmanDrugNameExists'] ? 'no-text-Transform' : ''">
                                            {{item[rxheader['hName']]}}
                                        </div>
                                    </ng-template>
                                    <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-item="item">
                                        <div title={{rxheader.hName}}>
                                            {{ rxheader.hName}}
                                        </div>
                                    </ng-template>
                                </wj-flex-grid-column>
                                <app-no-data-found *ngIf="!totalNYRecordsLength"></app-no-data-found>
                            </wj-flex-grid>
                            <app-eprx-pagination [TotalCount]="totalNYRecordsLength" *ngIf="totalNYRecordsLength"
                            (OnPageSelected)="setPage($event, 'NYcontrlError')"
                            (OnSizeSelected)="setSize($event, 'NYcontrlError')"
                            [GridName]="'NYErrorGrid'"
                                [WijmoName]="NYErrorFile"
                                [PageNumber]="pageNumber"
                                [PageSize]="pageSize"
                                (OnFocusOut)="focusToFirst($event)"
                                ></app-eprx-pagination>
                            <div class="row mt-0">
                                <div class="col-12">
                                    <div class="row">
                                        <div class="col-2">
                                            <p >{{selectedFilter?.['Name'] === 'All' ? 'Total Count:' : (selectedFilter?.['Name'] == 'Resolved' ? 'Total Resolved Count:' : 'Total Unresolved Count:')}} {{totalNYRecordsLength}}</p>

                                        </div>
                                        <div class="col-2 margin_left_n8rem"  *ngIf="selectedFilter?.['Name'] == 'All'">
                                            <p>Resolved Count: {{resolvedCountNY?.length}}</p>
                                        </div>
                                        <div class="col-5 margin_left_n6rem" *ngIf="selectedFilter?.['Name'] == 'All'">
                                            <p>Unresolved Count: {{unResolvedCountNY?.length}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</div>
<div class="modal-footer">
    <div class="text-end pull-right col-md-10 padding-0">
        <button type="button" class="hotkey_primary" (click)="closePopUp()" appShortcutKey InputKey="c">
            <b>C</b> Close
        </button>
    </div>
</div>
